import React, { useEffect, useState } from "react";

const SingleColor = ({ weight, index, hex }) => {
	const [alert, setAlert] = useState(false);

	const hexValue = `#${hex}`;

	const handleClick = () => {
		setAlert(true);
		navigator.clipboard.writeText(hexValue);
	};

	useEffect(() => {
		const timeOut = setTimeout(() => {
			setAlert(false);
		}, 3000);
		return () => clearTimeout(timeOut);
	}, [alert]);

	return (
		<>
			<div
				key={index}
				style={{
					backgroundColor: `${hexValue}`,
					color: `${index > 10 && "#fff"}`
				}}
				onClick={handleClick}
				id="colors"
				className="p-5 transition-all duration-500 cursor-pointer flex text-center flex-col justify-center rounded"
			>
				{hexValue}
				<p className="  "> {alert && "copied"} </p>
			</div>
		</>
	);
};

export default SingleColor;
